import React, { useEffect, useState, useCallback } from "react";
import { useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import { Grid } from "@mui/material";
import Card from "../../components/Cards/Card";
import NativeObject from "../../components/NativeObject/NativeObject";
import { useSelections } from "../../context/Selections";
import LayoutWrapper from "../../components/LayoutWrapper/LayoutWrapper";
import { Footer } from "../../components/Footer/Footer";
import CoberturaBaseCard from "./components/CoberturaBaseCard";
import PcSkinsCard from "./components/PcSKinCard";
import CanaisDigitaisCard from "./components/CanaisDigitaisCard";
import PontosTopCard from "./components/PontosTopCard";
import SellThruEucerinCard from "./components/SellThruEurecinCard";
import SellThruNiveaCard from "./components/SellThruNiveaCard";
import ResultadosCard from "./components/ResultadosCard";
import { OverviewCardSkeleton } from "../../components/Cards";
import { useOverviewData } from "../../hooks";

const OBJECT_IDS = {
  RANKING: "tjQzgaU",
};

function OverviewDesktop({ app }) {
  const { selections } = useSelections();
  const [nameUser, setNameUser] = useState("");
  const { isLoading } = useOverviewData(app);
  const location = useLocation();
  const segment = new URLSearchParams(location.search).get("segment");

  const getNameUser = useCallback(
    async (objectId) => {
      if (app && objectId) {
        try {
          const res = await app.visualization.get(objectId);
          const value = res?.model?.layout?.style?.label;
          setNameUser(value);
        } catch (error) {
          console.error("Erro ao buscar nome do usuário:", error);
        }
      }
    },
    [app]
  );

  useEffect(() => {
    if (app) {
      getNameUser(OBJECT_IDS.USER_NAME);
    }
  }, [app, getNameUser, selections]);

  return (
    <div className="app overview">
      <div className="appContent">
        <LayoutWrapper>
          <Grid
            container
            flexDirection="column"
            justifyContent="flex-start"
            rowGap={1}
          >
            {isLoading ? (
              <Grid container spacing={2} sx={{ marginBottom: "20px" }}>
                <Grid item xs={12} md={6} lg={3}>
                  <OverviewCardSkeleton variant="rectangular" />
                </Grid>
                <Grid item xs={12} md={6} lg={3}>
                  <OverviewCardSkeleton variant="rectangular" />
                </Grid>
                <Grid item xs={12} md={6} lg={3}>
                  <OverviewCardSkeleton variant="rectangular" />
                </Grid>
                <Grid item xs={12} md={6} lg={3}>
                  <OverviewCardSkeleton variant="rectangular" />
                </Grid>
                <Grid item spacing={2} xs={12}>
                  <OverviewCardSkeleton variant="performance" />
                </Grid>
              </Grid>
            ) : (
              <Grid item spacing={2} sx={{ marginBottom: "20px" }}>
                <Grid container spacing={2}>
                  <Grid
                    item
                    xs={12}
                    md={6}
                    lg={3}
                    className="container-tables-tops"
                  >
                    <CoberturaBaseCard app={app} segment={segment} />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    md={6}
                    lg={3}
                    className="container-tables-tops"
                  >
                    <PcSkinsCard app={app} segment={segment} />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    md={6}
                    lg={3}
                    className="container-tables-tops"
                  >
                    <CanaisDigitaisCard app={app} segment={segment} />
                  </Grid>
                  {segment === "farma" && (
                    <Grid
                      item
                      xs={12}
                      md={6}
                      lg={3}
                      className="container-tables-tops"
                    >
                      <SellThruEucerinCard app={app} />
                    </Grid>
                  )}
                  <Grid
                    item
                    xs={12}
                    md={6}
                    lg={3}
                    className="container-tables-tops"
                  >
                    <PontosTopCard app={app} segment={segment} />
                  </Grid>
                  {segment === "farma" && (
                    <Grid
                      item
                      xs={12}
                      md={6}
                      lg={3}
                      className="container-tables-tops"
                    >
                      <SellThruNiveaCard app={app} />
                    </Grid>
                  )}
                </Grid>
                {segment !== "farma" && (
                  <Grid item spacing={2}>
                    <ResultadosCard app={app} segment={segment} />
                  </Grid>
                )}
                {segment === "farma" && (
                  <Grid item spacing={2}>
                    <Card
                      app={app}
                      className={"card-kpi-item"}
                      header={{ hardTitle: "Resultados" }}
                      expandable
                      exportContainer
                      exportTable
                      exportTableId={"mkFPRKV"}
                    >
                      <NativeObject
                        app={app}
                        key={"mkFPRKV"}
                        reference={{ id: "mkFPRKV" }}
                        style={{ width: "100%", height: "420px" }}
                      />
                    </Card>
                  </Grid>
                )}
                <Grid item spacing={2}>
                  <Footer app={app} />
                </Grid>
              </Grid>
            )}
          </Grid>
        </LayoutWrapper>
      </div>
    </div>
  );
}

OverviewDesktop.propTypes = {
  app: PropTypes.object,
};

export default OverviewDesktop;
